import React from "react";
import Slider from "react-slick";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTestimonial } from "../../features/testimonialSlice";
const Testimonial = () => {
  const dispatch = useDispatch();

  const { testimonial, status, error } = useSelector(
    (state) => state.testimonial
  );

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoPlay: true,
    arrows: false,

    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchTestimonial());
    }
  }, [dispatch, status]);

  return (
    <>
      {testimonial && testimonial.length > 0 ? (
        <div className="testimonial-bg pt-40 pb-40">
          <div className="container">
            <div className="row">
              <div className="col-12 main-heading-inner-box">
                <div className="inner-box">
                  <h3 className="main-heading-1">What our client say </h3>
                </div>
              </div>
            </div>
            {testimonial.length >= 3 ? (
              <>
                <Slider
                  {...settings}
                  autoplay="true"
                  className="main-testimonialslide">
                  {testimonial.map((datas, index) => {
                    return (
                      <div className="testimonial-cardmain" key={index}>
                        <div className="testimonial-card">
                          <p>{datas.description}</p>
                          <div className="testm-botom">
                            <div className="testimonial-name">
                              <img
                                src={datas.profile_img}
                                alt="img"
                                className="testimonial-icon"
                              />
                              <h6>
                                <span>{datas.client_name}</span> - {datas.place}
                              </h6>
                            </div>

                            <div className="rating">
                              {[...Array(5)].map((star, index) => {
                                return (
                                  <span
                                    key={index}
                                    className={`fa fa-star ${
                                      index < datas.review_count
                                        ? "checked"
                                        : ""
                                    }`}
                                  ></span>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </>
            ) : testimonial.length == 2 ? (
              <>
                <div className="row" style={{ justifyContent: "center" }}>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    {testimonial.map((datas, index) => {
                      return (
                        <div className="testimonial-cardmain" key={index}>
                          <div className="testimonial-card">
                            <p>{datas.description}</p>
                            <div className="testm-botom">
                              <div className="testimonial-name">
                                <img
                                  src={datas.profile_img}
                                  alt="img"
                                  className="testimonial-icon"
                                />
                                <h6>
                                  <span>{datas.client_name}</span> -{" "}
                                  {datas.place}
                                </h6>
                              </div>

                              <div className="rating">
                                {[...Array(5)].map((star, index) => {
                                  return (
                                    <span
                                      key={index}
                                      className={`fa fa-star ${
                                        index < datas.review_count
                                          ? "checked"
                                          : ""
                                      }`}
                                    ></span>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : testimonial.length == 1 ? (
              <>
                <div className="row" style={{ justifyContent: "center" }}>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    {testimonial.map((datas, index) => {
                      return (
                        <div className="testimonial-cardmain" key={index}>
                          <div className="testimonial-card">
                            <p>{datas.description}</p>
                            <div className="testm-botom">
                              <div className="testimonial-name">
                                <img
                                  src={datas.profile_img}
                                  alt="img"
                                  className="testimonial-icon"
                                />
                                <h6>
                                  <span>{datas.client_name}</span> -{" "}
                                  {datas.place}
                                </h6>
                              </div>

                              <div className="rating">
                                {[...Array(5)].map((star, index) => {
                                  return (
                                    <span
                                      key={index}
                                      className={`fa fa-star ${
                                        index < datas.review_count
                                          ? "checked"
                                          : ""
                                      }`}
                                    ></span>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Testimonial;
